// Digital gift card form behavior. Loaded only by product-form-digital-card.liquid,
// which renders for products 171066294299 and 1871046574150.

function updateDigitalGiftCardForm() {
  function notifyChange(field) {
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function handleUpdate(deliveryMethodSelect, giftCardForm) {
    const isEmail = deliveryMethodSelect.value === 'Email';

    giftCardForm.classList.toggle('Email', isEmail);
    giftCardForm.classList.toggle('Shipped', !isEmail);

    if (isEmail) {
      const deliveryDate = document.querySelector('#delivery-date');
      if (deliveryDate) {
        deliveryDate.value = 'immediately';
        notifyChange(deliveryDate);
      }
    } else {
      const fields = document.querySelectorAll(
        '.product-digitalgiftcard-form input, .product-digitalgiftcard-form textarea'
      );
      fields.forEach((field) => {
        field.value = '';
      });
      fields.forEach(notifyChange);
    }

    giftCardForm.querySelectorAll('input, textarea').forEach((field) => {
      field.required = isEmail;
      field.disabled = !isEmail;
    });
  }

  function initializeListener(selector) {
    // Bound to every select in .variations (delivery method and amount), but the
    // state is always derived from the first, which is the delivery method.
    const selects = document.querySelectorAll(selector + ' .variations select');
    const giftCardForm = document.querySelector(selector + ' .product-digitalgiftcard-form');

    if (!selects.length || !giftCardForm) return;

    selects.forEach((select) => {
      select.addEventListener('change', function () {
        handleUpdate(selects[0], giftCardForm);
      });
    });
  }

  initializeListener('.product-information');

  function changeOtherForm(currentElements) {
    const isEmail = currentElements[0].value === 'Email';
    const modeClass = isEmail ? 'Email' : '';

    document.querySelectorAll('.product-digitalgiftcard-form').forEach((el) => {
      el.classList.remove('Email', 'Shipped');
      if (modeClass != '') {
        el.classList.add(modeClass);
      }
    });

    document.querySelectorAll(`[rel='${currentElements[0].value}']`).forEach((el) => {
      el.click();
    });

    const deliveryDateInput = document.querySelector('#delivery-date');
    if (deliveryDateInput) {
      deliveryDateInput.value = 'immediately';
    }
  }

  const digitalGiftCardInput = document.querySelectorAll('.product-information .variations select');

  digitalGiftCardInput.forEach((el) => {
    el.addEventListener(
      'change',
      function () {
        changeOtherForm(digitalGiftCardInput);
      },
      true
    );
  });

  // Delegated, because a variant change makes product.js rewrite the sticky bar's
  // innerHTML and a listener bound straight to the button would die with the old node.
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.gift-card-product-js-bind');
    if (!button) return;
    e.preventDefault();

    // The delivery-method select renders in .product-information; the sticky bar has
    // no select of its own, so it has to be read from the main form.
    const selects = document.querySelectorAll('.product-information .variations select');
    const deliveryMethodSelect =
      Array.from(selects).find((select) => select.querySelector('option[value="Email"]')) ||
      selects[0];

    // Virtual cards need the recipient fields up in the main form, so send the
    // shopper there instead of submitting.
    if (!deliveryMethodSelect || deliveryMethodSelect.value === 'Email') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const mainSubmit = document.querySelector(
      `.product-information [form='${button.dataset.form_id}'][type='submit']`
    );
    if (mainSubmit) mainSubmit.click();
  });
}

if (document.readyState === 'complete') {
  updateDigitalGiftCardForm();
} else {
  document.addEventListener('DOMContentLoaded', updateDigitalGiftCardForm);
}
